import React                 from "react";
import { last as _last, split as _split } from "lodash";

import MywortModalWrapper    from "../../../commons/components/MywortModalWrapper";
import Modal                 from "react-bootstrap/lib/Modal";
import StringUtils           from "../../../commons/utils/StringUtils";

import { GroupApi }          from "../../api/Api";

import { Translation }       from "../../../commons";


export default class GroupDetailsModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState = () => ({
        showModal: false,
        group: undefined
    });

    getGroup = () => {
        let groupId = _last(_split(window.location.href, "/"));
        GroupApi.getGroup(groupId).then( (group) => {
            this.setState({
                group: group,
                showModal: true
            });
        });
    };

    showModal = (e) => {
        e.stopPropagation();
        e.preventDefault();
        if(!this.state.group)
            this.getGroup();
        else
            this.setState({showModal: true});
    };

    hideModal = () => this.setState({showModal: false});

    renderModal = () => (
        <MywortModalWrapper show onHide={this.hideModal} backdrop>
            <Modal.Header className="mywort-modal__header" closeButton>
                <Modal.Title className="mywort-modal__title">{this.state.group.name}</Modal.Title>
                <p className="group-details-modal__locality">{ this.state.group.locality }</p>
            </Modal.Header>
            <Modal.Body className="group-details-modal__body">
                { this.state.group.mainPicture ? <img src={this.state.group.mainPicture.thumbnail} alt={this.state.group.name}/> : <div className="group-details-modal__no-picture"></div> }
                <div className="group-details-modal__description">{ StringUtils.withLineBreakAsHtml(this.state.group.description) }</div>
            </Modal.Body>
        </MywortModalWrapper>
    );

    renderReadMoreButton = () => (
        <a href="" className="group-details-modal__read-more-button u-text-underline" onClick={this.showModal}>
            { Translation.translate("commons.about") }
        </a>
    );

    render = () => (
        <div>
            { this.renderReadMoreButton() }
            { this.state.showModal ? this.renderModal() : null }
        </div>
    );

}



// WEBPACK FOOTER //
// ./js/mywort/frontend/pages/groupDetailsModal/GroupDetailsModal.jsx